import React from "react";
import Title from '../images/BigLogoBackground.svg'

const Header = () => {
  return (
    <div >
      <img className="title" src={Title} alt="DarLey Paint"/>
    </div>
  )
}

export default Header;